import React from 'react';

import styles from './MainButtonWithBackground.module.scss';

const MainButtonWithBackground = ({text, width, type, condition, onClick}) => {
    return (
        <button
            onClick={onClick && onClick}
            disabled={condition}
            type={type}
            style={{width}}
            className={styles.button}
        >
            {text}
        </button>
    );
};

export default MainButtonWithBackground;